import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var Svg18LogoutG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("path", {
        id: "18-logout-g_svg__a",
        d: "M0 0h14v13.417H0z"
      })
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsxs("g", {
        transform: "translate(2 3.167)",
        children: [/*#__PURE__*/jsx("mask", {
          id: "18-logout-g_svg__b",
          fill: "#fff",
          children: /*#__PURE__*/jsx("use", {
            xlinkHref: "#18-logout-g_svg__a"
          })
        }), /*#__PURE__*/jsx("path", {
          fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
          d: "M7 13.417c-3.86 0-7-3.14-7-7A7.04 7.04 0 0 1 3.97.104a.585.585 0 0 1 .506 1.052 5.87 5.87 0 0 0-3.31 5.26A5.84 5.84 0 0 0 7 12.25a5.84 5.84 0 0 0 5.833-5.833 5.85 5.85 0 0 0-3.4-5.304.58.58 0 0 1-.286-.773.58.58 0 0 1 .773-.286A7.02 7.02 0 0 1 14 6.417c0 3.86-3.14 7-7 7",
          mask: "url(#18-logout-g_svg__b)"
        })]
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey400,
        d: "M9 10.167a.583.583 0 0 1-.583-.584v-7a.582.582 0 1 1 1.166 0v7a.583.583 0 0 1-.583.584"
      })]
    })]
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18LogoutG$1 = Svg18LogoutG;

export { Svg18LogoutG$1 as default };
